(ns pfo.auth.component
  (:require [reagent.core :as reagent :refer [atom]]
            [pfo.auth.model :as auth-model]
            [pfo.util :as util :refer [reset-from-event]]
            [pfo.form :refer [set-selected set-checked]]
            [pfo.widget.autocomplete :refer [react-select-styles]]
            [pfo.auth.model :as model]
            ["react-select" :default Select]))

(defn user-chooser [options user-list value-atom]
  [:select (merge
             {:on-change (fn [ev]
                           ((reset-from-event value-atom) ev)
                           (some-> (:change-cb options) (apply nil)))
              :value @value-atom}
             (when (:disabled options) {:disabled :disabled}))
   [:option {:value ""} "Choose user"]
   (doall
     (for [auser user-list]
       [:option {:key (str "user-" (:id auser)) :value (:id auser)} (model/get-full-name auser)]))])

(defn user-chooser-multi [user-list value-atom]
  [:ul.users
   (doall
     (for [auser user-list]
       (let [user-id (:id auser)]
         [:li {:key (:id auser)}
          [:label
           [:input (set-checked
                     (contains? @value-atom user-id)
                     {:on-click (fn [ev]
                                  (let [selected (-> ev .-target .-checked)]
                                    (if selected
                                      (swap! value-atom conj user-id)
                                      (swap! value-atom disj user-id))))})]
           (model/get-full-name auser)]])))])

(defn user-chooser-fuzzy [opts user-list value-atom]
  (let [options (map (fn [user] {:label (auth-model/get-full-name user) :value (:id user)}) user-list)]
    [:>
     Select
     (merge
      {:class (:class opts)
       :classNamePrefix (:class-prefix opts)
       :options     (if (and (:allow-empty opts) (not-empty (str @value-atom)))
                      (merge options {:label "Not selected" :value ""})
                      options)
       :placeholder (if (:disabled opts) "" "Choose")
       :isDisabled  (or (not (seq options)) (:disabled opts))
       :value       (filter (fn [category] (= @value-atom (:value category))) options)
       :on-change   (fn [e]
                      (reset! value-atom (-> (js->clj e :keywordize-keys true) :value))
                      (some-> (:change-cb opts) (apply nil)))}
      ((if (:theme opts) (:theme opts) :primary) react-select-styles))]))

(defn mfa
  ([options code-url] (mfa options code-url nil))
  ([options code-url qrcode]
   (let [code (atom "")
         errors (atom {})
         mfa-submit (fn [e]
                      ((:success-cb options) code-url code errors)
                      (.preventDefault e))
         classes (merge {:form ""
                         :image ""
                         :input "c-login__input"
                         :description ".u-text-align--justify"} (:classes options))]
     (fn [options code-url qrcode]
       [:div
        (when qrcode
          [:div
           [:p {:class (:description classes)} "To start using a token generator, please use your smartphone to scan the QR code below. "
            [:a {:target "_blank"
                 :href "https://support.google.com/accounts/answer/1066447?hl=en"}
             "Google Authenticator"]
            " app can be used for this. Then, enter the token generated by the app."]
           [:div {:class (:image classes) } [:img {:align "center" :src (str "data:image/png;base64," qrcode)}]]] )

        [:form {:on-submit mfa-submit
                :class (:form classes)}
         [:p "Authentication token:"]
         [:dl
          [:dd
           [:input {:class (:input classes)
                    :type "text" :required "required"
                    :auto-focus "autofocus"
                    :autocomplete "one-time-code"
                    :on-change #(reset! code (-> % .-target .-value))}]]]
         [:dl
          [:dd.error (:code @errors)]]

         [:footer.c-login__footer
          [:button.c-button--dark-blue {:on-click (util/handler (:cancel-cb options)) :type :button} "Cancel"]
          [:button.c-button--dark-blue {:type :submit} "Verify"]]]]))))

(defn error-page [message]
  [:div message])

(defn user-info-container [user]
  (let [user (js->clj user :keywordize-keys true)]
    [:div.c-info-details
     (when (or (not-empty (:first_name user) ) (not-empty (:last_name user) )  )
       [:div [:label [:b "Name: "]] (str (:first_name user) " " (:middle_name user) " " (:last_name user) " " (:suffix user))] )

     (doall (for [[user-field label highlighted] [[:company_name "Company: " false] [:title "Title/Role: " false] [:email "E-mail: " false] [:phone_number "Phone Number: " false]
                                      [:physical_address_line_1 "Street Address: " false]
                                      [:physical_address_line_2 "Suite/Unit Number: " false]
                                      [:physical_address_city "City: " false]
                                      [:physical_address_country "Country: " false]
                                      [:physical_address_state "State: " false]
                                      [:physical_address_zip "Zip Code: " false]
                                      [:ssn_ein "SSN/EIN: " false]
                                      [:citizenship_status "Citizenship Status: " false]
                                      [:fin_cen_id "FinCEN ID: " true]
                                      [:physical_address_type "Address Type: " false]]]
              (when (not-empty (user-field user))
                [:div (merge
                        {:key label}
                        (when highlighted {:class :u-color--highlighted})) [:label [:b label]]
                 (if (= user-field :email ) [:a {:href (str "mailto:" (user-field user))} (user-field user) ]
                     (user-field user))])))]))
